// extracted by mini-css-extract-plugin
export default {"card":"styles_card__LMORu","autocomplete":"styles_autocomplete__vM09j"};